import { ControlPosition, MapControl, useMap } from "@vis.gl/react-google-maps";
// import React, { useState } from "react";
// import { Card, Form } from "react-bootstrap";
import GroupSelector from "../groupSelector/GroupSelector";

const TrackingSearch = ({ report }) => {
  const map = useMap();
  // const [input, setInput] = useState("");
  const onSelect = (e) => {
    // currentRef.current = e;
    // setCurrent(e);
    if (
      (e.type === "assets" || e.type === "people") &&
      e.lastPosition &&
      e.lastPosition.latitude &&
      e.lastPosition.longitude &&
      map
    ) {
      map.panTo({
        lat: Number(e.lastPosition.latitude),
        lng: Number(e.lastPosition.longitude),
      });
      // map.setCenter({
      //   lat: Number(e.lastPosition.latitude),
      //   lng: Number(e.lastPosition.longitude),
      // });
      // centerRef.current = {
      //   lat: Number(e.lastPosition.latitude),
      //   lng: Number(e.lastPosition.longitude),
      // };
      map.setZoom(18);
    } else if (e.type === "zones" && e.longitude && e.latitude) {
      map.panTo({ lat: Number(e.latitude), lng: Number(e.longitude) });
      map.setCenter({ lat: Number(e.latitude), lng: Number(e.longitude) });
      // centerRef.current = { lat: Number(e.latitude), lng: Number(e.longitude) };
      map.setZoom(18);
    }
    // onSetFilter(null);
  };

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <GroupSelector
        onSelect={onSelect}
        report={report}
        style={{ position: "relative" }}
      ></GroupSelector>
    </MapControl>
  );
};

export default TrackingSearch;
